/**
 * @module BeneficiarySync
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

export default keyMirror({
  FETCH_BENEFICIARY_TO_SYNC: null,
  FETCH_BENEFICIARY_SUCCESSS: null,
  FETCH_BENEFICIARY_FAIL: null,
  ADD_BENEFICIARY: null,
  ADD_BENEFICIARY_SUCCESSS: null,
  ADD_BENEFICIARY_FAIL: null,
});
